import React from 'react';
import {string} from 'prop-types';
import sample from 'lodash/sample';
import {Redirect} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {Grid, Image, Container} from 'semantic-ui-react';
import {ReactionGifs} from 'components/common/ReactionGifs';

const ONE_SECOND = 1 * 1000;
const COUNTDOWN_LENGTH = ONE_SECOND * 8;

export default class NoAccessPage extends React.Component {
  static propTypes = {
    redirectUrl: string
  };

  static defaultProps = {
    redirectUrl: '/'
  };

  state = {
    intervalId: null,
    reactionGif: null,
    countdownMillis: null
  };

  componentDidMount() {
    this.setState({
      intervalId: setInterval(this.timer, ONE_SECOND),
      reactionGif: sample(ReactionGifs.NEGATIVE),
      countdownMillis: COUNTDOWN_LENGTH
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  timer = () => {
    this.setState(prevState => ({
      countdownMillis: prevState.countdownMillis - ONE_SECOND
    }));
  };

  render() {
    return (
      this.state.countdownMillis === 0
        ? <Redirect to={this.props.redirectUrl} />
        : (
          <Grid center columns={1}>
            <Grid.Column textAlign='center'>
              <Grid.Row>
                <Image centered src={this.state.reactionGif} />
              </Grid.Row>
              <Grid.Row>
                <Container text className='no-access-message-container'>
                  <FormattedMessage
                    id='redirect.noAccess'
                    values={{seconds: this.state.countdownMillis / ONE_SECOND}} />
                </Container>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        )
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/NoAccessPage.jsx